<template>
  <div class="commonProgress">
    <div class="percentage">
      {{ title }}
    </div>
    <div class="slide">
      <el-progress
        :show-text="false"
        :percentage="progress"
        color="#2F58FE"
        bacground="#DCDDE0"
      ></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonProgress',
  components: {},
  props: {
    title: String,
    progress: { type: Number, default: 0 }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.commonProgress {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .percentage {
    height: 13px;
    line-height: 13px;
    margin-top: 4px;
    font-size: 12px;
    color: #333333;
  }
  .slide {
    margin-top: 7px;
    width: 100%;
    height: 8px;
  }
}
</style>
